<ah-date-range-picker fxFlexFill [showPicker]="true"
  [config]="{'currentStartValue': data?.from_date,
                    'currentEndValue': data?.to_date, 'showCustomRangeLabel': false}"
  (dateChange)="datePickerChange($event)"></ah-date-range-picker>
